<ion-header>
  <ion-toolbar>
    <ion-title>Help me decide...</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="start" *ngIf="step === 2">
      <ion-button (click)="setStep(1)">
        <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  
  <div class="progress-container ion-margin-bottom">
    <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
        <small>Step {{ step }} of {{ maxStep }}</small>
        <small *ngIf="step === 1">What are you sharing?</small>
        <small *ngIf="step === 2">Formatting</small>
    </div>
    <ion-progress-bar [value]="step / maxStep"></ion-progress-bar>
  </div>

  <ng-container *ngIf="step === 1">
    <ion-list lines="full">
      <ion-item button detail="true" *ngIf="hasWordpressTarget" (click)="selectType('wordpress')">
        <ion-avatar slot="start" class="method-icon">
            <div class="icon-wrapper">
                <ion-icon src="assets/icon/menu/dark/logo-wordpress.svg"></ion-icon>
            </div>
        </ion-avatar>
        <ion-label>
          <h2>WordPress article</h2>
          <p class="muted">Publish to WordPress, then share everywhere</p>
        </ion-label>
      </ion-item>

      <ion-item button detail="true" (click)="selectType('link')">
        <ion-avatar slot="start" class="method-icon">
          <div class="icon-wrapper">
              <ion-icon name="link-outline"></ion-icon>
          </div>
      </ion-avatar>
        <ion-label>
          <h2>Link</h2>
          <p class="muted">Share a URL with your commentary</p>
        </ion-label>
      </ion-item>

      <ion-item button detail="true" (click)="selectType('photo_step')">
        <ion-avatar slot="start" class="method-icon">
          <div class="icon-wrapper">
              <ion-icon src="assets/icon/menu/dark/image.svg"></ion-icon>
          </div>
      </ion-avatar>
        <ion-label>
          <h2>Photo</h2>
          <p class="muted">Image-first post</p>
        </ion-label>
      </ion-item>

      <ion-item button detail="true" (click)="selectType('social-card')">
        <ion-avatar slot="start" class="method-icon">
          <div class="icon-wrapper">
            <ion-icon src="assets/icon/menu/dark/social-card.svg"></ion-icon>
          </div>
      </ion-avatar>
        <ion-label>
          <h2>Quote/headline graphic</h2>
          <p class="muted">Branded text-on-image (template)</p>
        </ion-label>
      </ion-item>

      <ion-item button detail="true" (click)="selectType('text')">
        <ion-avatar slot="start" class="method-icon">
          <div class="icon-wrapper">
              <ion-icon src="assets/icon/menu/dark/create.svg"></ion-icon>
          </div>
      </ion-avatar>
        <ion-label>
          <h2>Just text</h2>
          <p class="muted">No link required</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>

  <ng-container *ngIf="step === 2 && path === 'photo'">
    <h3 class="ion-text-center ion-margin-bottom">Do you want text + branding on the image?</h3>
    
    <ion-list lines="full">
      <ion-item button detail="true" (click)="selectType('social-card')">
        <ion-icon name="checkmark-circle-outline" slot="start" color="primary"></ion-icon>
        <ion-label class="ion-text-wrap">
          <h2>Yes</h2>
          <p class="muted">Then you want a Social Card</p>
        </ion-label>
      </ion-item>

      <ion-item button detail="true" (click)="selectType('photo')">
        <ion-icon name="close-circle-outline" slot="start" color="medium"></ion-icon>
        <ion-label class="ion-text-wrap">
          <h2>No</h2>
          <p class="muted">I will post the image as-is</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>

  <ng-container *ngIf="step === 2 && path === 'link'">
      <h3 class="ion-text-center ion-margin-bottom">Summarize Link Details</h3>
      
      <ion-list lines="none">
        <ion-item class="input-item">
            <ion-icon name="link" slot="start" color="medium"></ion-icon>
            <ion-input label="URL" labelPlacement="stacked" placeholder="https://..." [(ngModel)]="url" type="url"></ion-input>
        </ion-item>

        <ion-item class="input-item">
            <ion-icon name="list" slot="start" color="medium"></ion-icon>
            <ion-input label="Max Paragraphs" labelPlacement="stacked" [(ngModel)]="maxParagraphs" type="number" min="1" max="10"></ion-input>
        </ion-item>

        <ion-item class="input-item">
            <ion-icon name="mic" slot="start" color="medium"></ion-icon>
            <ion-select label="Tone" labelPlacement="stacked" [(ngModel)]="tone" interface="popover">
                <ion-select-option value="objective">Objective</ion-select-option>
                <ion-select-option value="insightful">Insightful</ion-select-option>
                <ion-select-option value="confident">Confident</ion-select-option>
                <ion-select-option value="empathetic">Empathetic</ion-select-option>
                <ion-select-option value="engaging">Engaging</ion-select-option>
                <ion-select-option value="trolling">Trolling</ion-select-option>
                <ion-select-option *ngFor="let customTone of account?.customTones" [value]="customTone.role">
                    {{ customTone.role | titlecase }}
                </ion-select-option>
            </ion-select>
        </ion-item>

        <ion-item class="input-item">
            <ion-icon name="pencil" slot="start" color="medium"></ion-icon>
            <ion-textarea label="Directions" labelPlacement="stacked" [(ngModel)]="directions" autoGrow="true" rows="2" placeholder="e.g. Summarize..."></ion-textarea>
        </ion-item>
      </ion-list>

      <div class="ion-padding">
         <ion-button class="ai-summarize-button" expand="block" (click)="submitLink()" [disabled]="!url">
             Summarize with AI
             <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
         </ion-button>
      </div>

  </ng-container>

</ion-content>
